export const Regex = {
    EMAIL_ADDRESS: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
    PHONE: /^[(]{0,1}[0-9]{3}[)]{0,1}\s[0-9]{3}-[0-9]{4}$/,
    INSTITUTION_PERSON_ID: /^[a-zA-Z0-9-]+$/,
};
